<template>
  
        <div v-show="needOtpLogin">
            <form class="login-form-otp" name="phoneForm"  v-show="!phoneNumSuccess && !otpProgress" novalidate>
                <div class="form-group">
                    <div class="input-group">
                         <!--v-pattern="phoneRegex" -->                        
                        <input material-animation v-validate="{ regex: /^[1-9]\d{9}$|^0[1-9]\d{9}$|^\+91[1-9]\d{9}$|^91[1-9]\d{9}$/ }" type="text" name="phoneNumber" class="form-control" v-model="user.phoneNumber" v-on:focus="phoneFocus = true" v-on:blur="phoneFocus = false" required>
                        <div class="input-label" v-bind:class="{ active: phoneFocus || user.phoneNumber }">Phone number</div>
                        <p v-show="errors.has('phoneNumber')" class="text-color error-text">Please enter valid phone number</p>
                    </div>
                    
                </div>
                <div>
                    <button type="button" class="btn btn-block btn-lg btn-red otp-button m-t-10" @click="getOtp(user)" v-bind:disabled="!validationCheck(user.phoneNumber) || errors.has('phoneNumber')">Send OTP</button>
                </div>  
            </form>
            <form class="login-form" name="otpForm" v-show="phoneNumSuccess && !otpProgress" novalidate>
                <div class="form-group m-b-0">
                    <div class="input-group">
                        <input material-animation v-validate="{numeric:true,min:4}" type="text" name="otpNumber" class="form-control" v-on:focus="otpFocus = true" v-on:blur="otpFocus = false" v-model="user.otp">
                        <div class="input-label" v-bind:class="{ active: otpFocus || user.otp }">Received OTP</div>
                        <p v-show="errors.has('otpNumber')" class="text-color error-text">Invalid OTP</p>
                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-primary btn-block m-t-10" @click="otpLogin(user)" v-bind:disabled="!validationCheck(user.otp) || errors.has('otpNumber')">Login</button>
                </div>
                <p v-if="!showResendOTP">Retry Sending OTP in <span class="time-counter m-t-10">{{timeCounter}}</span> second(s)</p>
                <div v-if="showResendOTP"><p class="resend-otp m-t-10" @click="getOtp(user)" v-bind:disabled="!validationCheck(user.phoneNumber)">Resend OTP</p></div>
            </form>
        </div>
</template>

<style lang="scss" scoped>
    .seperator-text {
        margin: 20%;
        text-align: center;
        font-size: 1.5em;
        font-family: OpenSans-Regular;
    }
    .login-form{
        &.login-form-google { 
            button {
                letter-spacing: inherit;
            }
        }
    }
</style>

<script>
import umsinit from './../mixins/umsinit';
export default {

  name: 'OtpLogin',
  props: ['phoneNumSuccess','timeCounter', 'showResendOTP' ],
  data () {
    return {
        phoneForm : Object,
        otpForm: Object,
        user: {
            phoneNumber : '',
            otp : ''
        },
        needOtpLogin: true,
        otpProgress: false,
        otpFocus : false,
        phoneFocus:false
    }
  },
  methods: {

      getOtp(user){
     
          this.$emit('getOtp', this.user.phoneNumber);      
      },
 
      otpLogin(users){

        const credentials = {
            mobile: this.user.phoneNumber,
            otp: this.user.otp
        }
        this.$emit('otpLogin', credentials);
      },
      validationCheck(data){
            let result = false;
            if (data > 0) {
                 result = true;
            }
            return result;
      }
      
  }

}
</script>


// WEBPACK FOOTER //
// src/components/OtpLogin.vue